import { observer } from 'mobx-react-lite';
import ModalWrapper from './ModalWrapper';
import type { ExportedModalProps, ModalWrapperProps } from './types';

export type { ExportedModalProps, ModalWrapperProps };

export default observer(ModalWrapper);
